@import "@/scss/use-bootstrap-mixins.scss";

$rowGap: 0.75rem;

#pricingTable {
  border: 1px solid #dedede;
  width: 100%;
  padding: 0;
  margin: 0;

  .totalSubtext {
    display: block;
    text-align: right;
    font-size: 0.9rem;
    font-weight: 400;
  }
}

.pricingTableHeader {
  background-color: $primary;
  display: flex;
  justify-content: space-between;
  padding: 20px;
  line-height: 1;
}

.fixedWidth {
  min-width: 95px;
  flex-grow: 0;

  @include media-breakpoint-up(sm) {
    width: 207px;
  }
}

.pricingTableHeaderTitle {
  color: $textColorOnPrimary !important;
  font-size: 1rem;
  font-weight: 700;
  margin: 0;
  padding: 0;
  text-transform: uppercase;

  &:last-child {
    text-align: right;
  }
}

.pricingTableBody {
  background-color: #fff;

  svg {
    width: 100%;
  }
}

.pricingTableChargeRow {
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  color: #000;
  font-size: 1rem;
  text-align: left;
  border-bottom: 1px solid #d8d8d8;
}

.discountBreakdown {
  display: flex;
  flex-direction: column;
  gap: $rowGap;

  > div {
    display: flex;
    flex-direction: column;
    gap: $rowGap;
    padding-left: 1.5rem;
    color: rgba(0, 0, 0, 0.75);
  }

  span {
    white-space: nowrap;
  }
}

.hasDiscount {
  display: flex;
  flex-direction: column;
  gap: $rowGap;
}

.chargePeriod {
  display: inline-block;
  margin-left: 0.4em;
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.75);
  white-space: nowrap;
}

.pricingTableChargeTotal {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  gap: $rowGap;
  text-align: right;
}

.discountTotalBreakdown {
  display: flex;
  flex-direction: column;
}

.pricingTableFooter {
  background-color: #fff;
  display: flex;
  justify-content: flex-end;
  padding: 1rem;
  font-size: 1rem;
  font-weight: 700;
}
